import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API = 'https://api.anti-bot.ai';

const MamdaniContext = createContext(null);

export function MamdaniProvider({ children }) {
  const [mamdaniMode, setMamdaniMode]   = useState(false);
  const [data,        setData]          = useState({ accounts: [], allBots: [] });
  const [loading,     setLoading]       = useState(false);
  const [lastFetch,   setLastFetch]     = useState(null);

  const fetchData = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res  = await fetch(`${API}/api/mamdani/watchlist-data`);
      const json = await res.json();
      if (json.success) {
        // build deduplicated allBots list
        const botMap = {};
        for (const acc of json.accounts || []) {
          for (const b of (acc.bots || [])) {
            if (!botMap[b.username] || b.bot_score > botMap[b.username].bot_score) {
              botMap[b.username] = b;
            }
          }
        }
        const allBots = Object.values(botMap).sort(
          (a, b) => b.is_coordinated - a.is_coordinated || b.bot_score - a.bot_score
        );
        setData({ accounts: json.accounts || [], allBots });
        setLastFetch(new Date());
      }
    } catch (e) {
      console.error('MamdaniContext fetch error:', e);
    }
    setLoading(false);
  }, [loading]);

  // fetch on first enable
  useEffect(() => {
    if (mamdaniMode && !lastFetch) {
      fetchData();
    }
  }, [mamdaniMode]);

  const toggleMode = () => setMamdaniMode(prev => !prev);

  // stats derived from data
  const stats = {
    totalBots:     data.allBots.length,
    botsCount:     data.allBots.filter(b => b.bot_type === 'BOT' || b.bot_type === 'LIKELY_BOT').length,
    antiIsrael:    data.allBots.filter(b => b.anti_israel_count > 0).length,
    coordinated:   data.allBots.filter(b => b.is_coordinated).length,
    accounts:      data.accounts.length,
  };

  return (
    <MamdaniContext.Provider value={{
      mamdaniMode,
      toggleMode,
      data,
      loading,
      lastFetch,
      refresh: fetchData,
      stats,
    }}>
      {children}
    </MamdaniContext.Provider>
  );
}

export function useMamdani() {
  const ctx = useContext(MamdaniContext);
  if (!ctx) throw new Error('useMamdani must be used inside MamdaniProvider');
  return ctx;
}
